/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const noop = (...args) => undefined;
noop.noop = true;
export default noop;
